import HttpService from "@core/services/http/http.service";
import { GetDetailResponse, GetListResponse } from "@app/types";
import { RequestParams, Signal } from "@core/services/http/http.type";
import { AffiliateCampaign, CreateAffiliateCampaign, UpdateAffiliateCampaign } from "@app/types";

class _AffiliateCampaignService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<AffiliateCampaign>>(
      "/admin/api/v3/affiliate-campaigns",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public get(campaignId: number) {
    return HttpService.get<GetDetailResponse<AffiliateCampaign>>(
      `/admin/api/v3/affiliate-campaigns/${campaignId}`
    );
  }

  public create(createAffiliateCampaign: CreateAffiliateCampaign) {
    return HttpService.post("/admin/api/v3/affiliate-campaigns", {
      body: { ...createAffiliateCampaign },
    });
  }

  public update(campaignId: number, updateAffiliateCampaign: UpdateAffiliateCampaign) {
    return HttpService.patch(`/admin/api/v3/affiliate-campaigns/${campaignId}`, {
      body: { ...updateAffiliateCampaign },
    });
  }

  public delete(campaignId: number) {
    return HttpService.delete(`/admin/api/v3/affiliate-campaigns/${campaignId}`);
  }
}

const AffiliateCampaignService = new _AffiliateCampaignService();

export default AffiliateCampaignService;
